import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=5fd36a21&scoped=true"
import script from "./Items.vue?vue&type=script&lang=ts"
export * from "./Items.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd36a21",
  null
  
)

export default component.exports